// @flow

import { createSelector } from 'reselect';

import { FRIEND_GROUP_ID, NEW_GROUP_ID } from '../../constants/friendConstants';

function getGroups(allGroups: Array<FriendGroup>) {
  // make sure to exclude the special 'friends' group, it's a fake group
  // there may come a time we need to exclude more, this will be the place for that;
  return allGroups.filter(group => group.id !== FRIEND_GROUP_ID && group.id !== NEW_GROUP_ID);
}

const interactableFriendGroupsSelector = createSelector(
  (state: GlobalState) => Object.values(state.friendGroups.groups),
  getGroups
);

export default interactableFriendGroupsSelector;
